import React, { useState, useMemo } from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import Appheader from './components/Appheader';
import Foot from './components/Foot';
import Footpost from './components/Footpost';
import Findd from './components/Findd';
import footballs from './data/footballs';
import './App.css';
import btnsweetalert from "./components/btnsweetalert.js";
import 'bootstrap/dist/css/bootstrap.min.css';
<link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200" />



function App() {
  const [selectedfootball, setSelectedfootball] = useState(null);
  const [searchText, setSearchText] = useState('');

  function onfootballOpenClick(theFootball) {
    setSelectedfootball(theFootball);
  }

  function onFootballCloseClick() {
    setSelectedfootball(null);
  }

  const filteredfootballs = useMemo(() => {
    return footballs.filter((football) => {
      return football.title.includes(searchText);
    });
  }, [searchText]);

  const footballcompo = useMemo(() => {
    return filteredfootballs.map((football, index) => {
      return <Foot key={index} football={football} onfootballOpenClick={onfootballOpenClick} />;
    });
  }, [filteredfootballs]);

  let footPost = null;
  if (selectedfootball) {
    footPost = <Footpost football={selectedfootball} onBgClick={onFootballCloseClick} />;
  }

  const handleSweetAlertClick = () => {
    btnsweetalert(); // Call the function to trigger SweetAlert
  };

  return (
    <div className="app bg-dark text-light text-uppercase">
      <div className='container'>
        
        <Appheader />

        <div className='p-4'>
          <Findd value={searchText} onValueChange={setSearchText} className="form-control"/>
        </div>
        <div className="row row-cols-2 row-cols-md-3 row-cols-lg-4">
          {footballcompo}
        </div>
        {footPost}
        
     <span>if you like click this</span><span className ="material-symbols-outlined sweetalert" onClick={handleSweetAlertClick}>
    favorite
</span>
      </div>
    </div>
  );
}

export default App;
